// import { AsyncStorage } from 'react-native';
import axios from 'axios';

const isDebug = false;

let params = {};
let body = {};
let method = 'GET';

interface ConstantVariables {
  headers?: any;
  body?: any;
  data?: any;
  params?: any;
  method?: any;
  url?: any;
}

export const API_URL = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '/');

const headers = {
  'content-Type': 'application/json',
};

let urlPath: any = window.location.pathname;
let locale = 'da';
urlPath = urlPath.split("/");
if (urlPath && urlPath[1]) {
  locale = urlPath[1];
}

async function connectAPI(url: string) {
  const resPromise = new Promise(async (resolve, reject) => {
    const options: ConstantVariables = {
      method,
      headers,
      url,
    };

    if (Object.keys(body).length !== 0 && body.constructor === Object) {
      options.data = body;
    }

    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      options.params = params;
    }

    if (isDebug) {
      // tslint:disable-next-line: no-console
      console.log('API Params:', options);
    }

    let response = null;

    response = await axios(options).then((res) => res ).catch(e => e.response);

    let isError = false;

    if (!response || response.status === 500) {
      isError = true;
    } else if (response.status === 415) {
      isError = true;
    }

    if (isError) {
      const err = {
        status: response.status ? 500 : response.status,
        isError: true,
        error: {
          message: 'Internal Server Error',
        },
      };

      reject(err);

    } else if (response && response.status !== 200) {
      const res = response.data || {};
      res.status = response.status;
      reject(res);
    } else {
      const res = response.data;
      res.status = response.status;
      resolve(res);
    }
  });

  return resPromise;
}

export const API = {
  getUserInfo() {
    const url = `${API_URL}api/v1/user/show`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  getUserCalendar(startDate: string, endDate: string, id: string) {
    const url = `${API_URL}api/v1/booking/getCalendar/${startDate}/${endDate}/${id}`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  getBooking(id: string) {
    const url = `${API_URL}api/v1/booking/formData/${id}/${locale}/`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  isAuthenticated() {
    const url = `${API_URL}api/v1/booking/isAuthenticated`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  submitBooking(bParams: object) {
    const url = `${API_URL}api/v1/booking/create`;
    params = {};
    body = bParams;
    method = 'POST';

    return connectAPI(url);
  },
  bookingInfoCalc(bParams: object) {
    const url = `${API_URL}api/v1/booking/bookingInfo/${locale}/`;
    params = {};
    body = bParams;
    method = 'POST';

    return connectAPI(url);
  },
  updateUserProfile(bParams: object) {
    const url = `${API_URL}api/v1/booking/updateUser/`;
    params = {};
    body = bParams;
    method = 'PUT';

    return connectAPI(url);
  },
  getPaymentBooking( id: string) {
    const url = `${API_URL}api/v1/booking/paymentLink/${id}`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  getPaymentForm( id: string) {
    const url = `${API_URL}api/v1/booking/paymentForm/${id}`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  getPaymentFormArgs( id: string) {
    const url = `${API_URL}api/v1/booking/paymentFormArgs/${id}`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  sendMessage(bParams: {}) {
    const url = `${API_URL}api/v1/message/send/`;
    params = {};
    body = bParams;
    method = 'POST';

    return connectAPI(url);
  },
  dogForm() {
    const url = `${API_URL}api/v1/user/dogForm/${locale}/`;
    params = {};
    body = {};
    method = 'GET';

    return connectAPI(url);
  },
  addDog(bParams: {}) {
    const url = `${API_URL}api/v1/user/addDog/`;
    params = {};
    body = bParams;
    method = 'POST';

    return connectAPI(url);
  },
};
